import Stripe from "stripe";
import { isNextJSServer } from "#/utils/environment";

export let stripe: Stripe = null as any;
// Initialize Stripe with your secret key
if (isNextJSServer()) {
  stripe = new Stripe(process.env.STRIPE_SECRET_KEY || "", {
    apiVersion: "2025-02-24.acacia" // Use the latest API version
  });
}